import { UtlTipoFornecimentoConfiguracao, DynamicFormSpec, filtrarCamposAtivos } from '@/models/utilidade/utl-tipo-fornecimento.model';
import api from '@/services/axios/api';
import TextoValor from '@/models/texto-valor';
import { UtlTipoFornecimentoModelPadrao } from '@/models/utilidade/utl-tipo-fornecimento.model';
import { AxiosResponse } from 'axios';
import GesFluxoAprovacaoDataSource from '@/datasources/gestao/fluxo-aprovacao/index.datasource';
import { GesFluxoAprovacaoModel } from '@/models/gestao/ges-fluxo-aprovacao.model';
import { DataSource } from 'consulte-framework-vue/components/grid';

function comCamposAtivos(spec: DynamicFormSpec | null | undefined): DynamicFormSpec {
  const form = spec ?? new DynamicFormSpec({ campos: [] });
  return {
    ...form,
    campos: filtrarCamposAtivos(form.campos)
  };
}

export default new (class UtlTipoFornecimentoService {
  async getCamposProduto(utlTipoFornecimentoId: number): Promise<DynamicFormSpec> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return comCamposAtivos(result.data.produto);
  }

  async getCamposLote(utlTipoFornecimentoId: number): Promise<DynamicFormSpec> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return comCamposAtivos(result.data.lote);
  }

  async getCamposRecebimento(utlTipoFornecimentoId: number): Promise<DynamicFormSpec> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return comCamposAtivos(result.data.recebimento);
  }

  async getCamposAplicacao(utlTipoFornecimentoId: number): Promise<DynamicFormSpec> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return comCamposAtivos(result.data.aplicacao);
  }

  async getControleFinanceiro(utlTipoFornecimentoId: number): Promise<string> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return result.data.controleFinanceiro;
  }

  async getPermiteEditarNumeracaoEnsaio(utlTipoFornecimentoId: number): Promise<boolean> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return result.data.permiteEditarNumeracaoEnsaio;
  }

  async getConfiguracao(utlTipoFornecimentoId: number): Promise<UtlTipoFornecimentoConfiguracao> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return result.data;
  }

  async getCamposFornecedorObra(utlTipoFornecimentoId: number): Promise<DynamicFormSpec> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return comCamposAtivos(result.data.fornecedorObra);
  }

  async getCamposContatos(utlTipoFornecimentoId: number): Promise<DynamicFormSpec> {
    const result = await api.get<UtlTipoFornecimentoConfiguracao>(`/UtlTipoFornecimento/Configuracao/${utlTipoFornecimentoId}`);
    return comCamposAtivos(result.data.contatos);
  }

  async getTiposFornecimento(): Promise<TextoValor[]> {
    const result = await api.get<TextoValor[]>(`/UtlTipoFornecimento/ListTipoFornecimento`);
    return result.data;
  }

  async listTipoFornecimentosParaCopiaUnidades(possuiUnidade: boolean): Promise<TextoValor[]> {
    const result = await api.get<TextoValor[]>(`/UtlTipoFornecimento/ListTipoFornecimentosParaCopiaUnidades?possuiUnidade=${possuiUnidade}`);
    return result.data;
  }

  async getTiposFornecimentoCompleto(): Promise<UtlTipoFornecimentoModelPadrao[]> {
    const result = await api.get<UtlTipoFornecimentoModelPadrao[]>(`/UtlTipoFornecimento`);
    return result.data;
  }

  async getTiposFornecimentoAtivos(): Promise<number[]> {
    const result = await api.get<number[]>(`/UtlTipoFornecimento/IdsAtivos`);
    return result.data;
  }

  async atualizarAtivo(utlTipoFornecimentoId: number, ativo: boolean): Promise<AxiosResponse> {
    return api.put(`/UtlTipoFornecimento/AtualizarAtivo`, null, {
      params: {
        utlTipoFornecimentoId,
        ativo
      }
    });
  }

  async salvarFluxoAprovacao(fluxos: GesFluxoAprovacaoModel[], tipo: number): Promise<AxiosResponse> {
    const result = await api.post<GesFluxoAprovacaoModel[]>(`/utlTipoFornecimento/SalvarFluxoAprovacao?tipo=${tipo}`, fluxos);
    return result;
  }

  async dadosFluxoAprovacaoPaginado(
    dataSource: GesFluxoAprovacaoDataSource,
    utlTipoFornecimentoId: number | null,
    segGrupoUsuarioId: number | null,
    tipo: number
  ): Promise<AxiosResponse<DataSource<GesFluxoAprovacaoModel>>> {
    try {
      dataSource.rows = [];

      const params: Record<string, number> = { tipo };

      if (utlTipoFornecimentoId != null) {
        params.utlTipoFornecimentoId = utlTipoFornecimentoId;
      }
      if (segGrupoUsuarioId != null) {
        params.segGrupoUsuarioId = segGrupoUsuarioId;
      }

      const response = await api.post<DataSource<GesFluxoAprovacaoModel>>('/utlTipoFornecimento/PaginadoFluxoAprovacao', dataSource, { params });

      return response;
    } catch (error) {
      console.error('Erro ao carregar os fluxos aprovação:', error);
      throw error;
    }
  }

  async atualizarCamposRecebimento(utlTipoFornecimentoId: number, data: string): Promise<AxiosResponse> {
    const result = await api.put<DynamicFormSpec>(`/UtlTipoFornecimento?utlTipoFornecimentoId=${utlTipoFornecimentoId}`, { data });

    return result;
  }
  async carregarUtl(): Promise<AxiosResponse> {
    return api.get('/UtlTipoFornecimento');
  }
  async carregarDescricao(utlTipoFornecimentoId: number): Promise<string> {
    const result = await api.get(`/UtlTipoFornecimento/TipoFornecimentoDescricao/${utlTipoFornecimentoId}`);
    return result.data;
  }

  async atualizarConfiguracaoEstoque(utlTipoFornecimentoId: number, rastreavelPorLote: boolean, controleEstoque: boolean): Promise<AxiosResponse> {
    return api.put(`/UtlTipoFornecimento/AtualizarConfiguracaoEstoque`, null, {
      params: {
        utlTipoFornecimentoId,
        rastreavelPorLote,
        controleEstoque
      }
    });
  }
})();
